import { render, staticRenderFns } from "./ListaComprasForm.vue?vue&type=template&id=74a6a2a6&"
import script from "./ListaComprasForm.vue?vue&type=script&lang=js&"
export * from "./ListaComprasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports